﻿export const HomePageLinkType = Object.freeze({
    Header: 10,
    FooterMyAccount: 20,
    FooterInformation: 30,
    FooterCustomerService: 40,
    SocialMediaLink: 50
});